if (typeof G == 'undefined') G = {};

(function GStorageUtilsIIFE() {

  G.StorageUtils = {
    setObjProp:                setObjProp,
    getObjProp:                getObjProp,
    filterAndMap:              filterAndMap,
    unique:                    unique,
    addUnique:                 addUnique,
    moveArrayElementToBeFirst: moveArrayElementToBeFirst,
    createDynamicMap:          createDynamicMap,
    createCache:               createCache,
    createRingBuffer:          createRingBuffer
  };

  return;

  function setObjProp(obj, prop, val) {

    var currentObj = obj;
    if (typeof prop === 'string') {
      prop = prop.split('.');
    }

    try {
      for (var i = 0; i < prop.length - 1; i++) {
        currentObj = currentObj[prop[i]];
      } 
      currentObj[prop[prop.length - 1]] = val;
    } catch(e) {
      return null;
    }

  }

  function getObjProp(obj, prop) {

    var current = obj;
    if (typeof prop === 'string') {
      prop = prop.split('.');
    }

    try {
      for (var i = 0; i < prop.length; i++) {
        current = current[prop[i]];
      }
    } catch(e) {
      return undefined;
    }

    return current;
  }

  function filterAndMap(array, func) {
    return array.reduce(
      function(acc, element, index, array) {
        var skip = false;
        var mapped = func(skipFunc, element, index, array);
        if (!skip) acc.push(mapped);
        return acc;
        function skipFunc() { skip = true; }
      },
      []
    );
  }

  function unique(array) {
    var result = [];
    array.forEach(function(elem) {
      if (result.indexOf(elem) === -1) {
        result.push(elem);
      }
    });
    return result;
  }

  function addUnique(array, element) {
    if (array.indexOf(element) === -1) {
      array.push(element);
    }
  }

  function moveArrayElementToBeFirst(array, element) {
    var index = array.indexOf(element);
    if (index > 0) {
        array.unshift(array.splice(index, 1)[0]);
        return true;
    }
    return false;
  }

  function createDynamicMap(createElementFunc) {

    var counter = 0;

    var map = {};

    var createSignal = new Phaser.Signal();

    return {
      getValue: getValue,
      setValue: setValue,
      hasKey: hasKey,
      removeKey: removeKey,
      getKeys: getKeys,
      forEachKeyValuePair: forEachKeyValuePair,
      createSignal: createSignal
    };

    function getValue(key) {
      if (hasKey(key)) {
        return map[key];
      } else {
        var oldCounterValue = counter;
        ++counter;
        var value = createElementFunc(key, oldCounterValue);
        map[key] = value;
        createSignal.dispatch(key);
        return value;
      }
    }

    function setValue(key, value) {
      map[key] = value;
    }

    function hasKey(key) {
      return map.hasOwnProperty(key);
    }

    function removeKey(key) {
      delete map[key];
    }

    function getKeys() {
      return Object.keys(map);
    }

    function forEachKeyValuePair(func) {
      Object.keys(map).forEach(function(key) { func(key, map[key]); });
    }
  }

  //

  function createCache(optGetKeyFromArgsFunc) {

    var getKeyFromArgsFunc = optGetKeyFromArgsFunc || defaultCacheKeyFunc;

    var cache = {};

    return {
      has: has,
      get: get,
      set: set,
      clear: clear
    };

    function has(/*arguments*/) {
      var key = getKeyFromArgsFunc.apply(null, arguments);
      return cache.hasOwnProperty(key);
    }

    function get(/*arguments*/) {
      if (has.apply(null, arguments)) {
        var key = getKeyFromArgsFunc.apply(null, arguments);
        return cache[key];
      }
      return null;
    }

    function set(data /*...rest*/) {
      var rest = Array.prototype.slice.call(arguments, 1);
      var key = getKeyFromArgsFunc.apply(null, rest);
      cache[key] = data;
      return data;
    }

    function clear() {
      cache = {};
    }
  }

  function defaultCacheKeyFunc(key) { return key; }

  //

  function createRingBuffer(size) {

    var array = [];
    var indexOfHead = 0;

    return {
      push: push,
      forEach: forEach,
      getActualSize: getActualSize
    };

    function push(value) {
      if (array.length < size) {
        array.push(value);
      } else {
        array[indexOfHead] = value;
        indexOfHead = (indexOfHead + 1) % size;
      }
    }

    function getActualSize() {
      return array.length;
    }

    function forEach(action) {
      for (var i = 0; i < array.length; ++i) {
        var index = (indexOfHead + i) % size;
        action(array[index], i);
      }
    }
  }

}());
